// Reset Password Page
import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    const res = await fetch('/api/auth/reset-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: params.get('token'), password })
    });
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="card bg-base-100 shadow-xl max-w-md w-full p-8">
        <h1 className="text-2xl font-bold mb-6 text-center">Reset Password</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="input input-bordered w-full" placeholder="New password" required />
          <button type="submit" className={`btn btn-primary text-white w-full ${loading ? 'loading' : ''}`} disabled={loading}>Reset Password</button>
        </form>
      </div>
    </div>
  );
}